import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconThumbsUpProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconThumbsUp: React.FC<IconThumbsUpProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Like',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10v12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconThumbsUp;
